import { useAnnouncementGetActiveAnnouncements } from "src/generated/endpoint";

export function useActiveAnnouncements () {
    const { data : activeAnnouncements, isLoading } = useAnnouncementGetActiveAnnouncements();
    return {
        activeAnnouncements, isLoading
    }
}
